export const ACCOUNT_LABELS = 'account';

// account addressBook
export const ACC_LBL_ADDRESS_BOOK_HEADING = 'ACC_LBL_ADDRESS_BOOK_HEADING';
export const ACC_LBL_ADD_NEW_ADDRESS_CTA = 'ACC_LBL_ADD_NEW_ADDRESS_CTA';
export const ACC_LBL_DELETE_ADDRESS_HEADING = 'ACC_LBL_DELETE_ADDRESS_HEADING';
export const ACC_LBL_DELETE_ADDRESS_TITLE = 'ACC_LBL_DELETE_ADDRESS_TITLE';
export const lblDeleteAddressModalCcAssociatedAddressMsg =
  'lbl_deleteAddressModal_ccAssociatedAddressMsg';
export const ACC_LBL_ADD_ADDRESS_FORM_HEADING = 'ACC_LBL_ADD_ADDRESS_FORM_HEADING';
export const ACC_LBL_EDIT_ADDRESS = 'ACC_LBL_EDIT_ADDRESS';
export const ACC_LBL_EDIT_ADDRESS_FORM_HEADING = 'ACC_LBL_EDIT_ADDRESS_FORM_HEADING';
export const ACC_LBL_CREATE_ADDRESS_BOOK_MSG = 'ACC_LBL_CREATE_ADDRESS_BOOK_MSG';
export const ACC_LBL_CREATE_ADDRESS_BOOK_BENEFIT_MSG = 'ACC_LBL_CREATE_ADDRESS_BOOK_BENEFIT_MSG';
export const ACC_LBL_DEFAULT_SHIPPING = 'ACC_LBL_DEFAULT_SHIPPING';
export const ACC_LBL_DEFAULT_BILLING = 'ACC_LBL_DEFAULT_BILLING';
export const ACC_LBL_SHIPPING = 'ACC_LBL_SHIPPING';

// account common
export const lblCommonSuccessMessage = 'lbl_common_successMessage';
export const lblCommonDontDelete = 'lbl_common_dontDelete';
export const lblCommonYesDelete = 'lbl_common_YesDelete';
export const lblCommonMakeDefault = 'lbl_common_makeDefault';
export const lblCommonDelete = 'lbl_common_delete';
export const lblCommonErrorMessage = 'lbl_common_errorMessage';

const AddressBookLabels = {
  account: {
    addressBook: {
      [ACC_LBL_ADDRESS_BOOK_HEADING]: 'ADDRESS BOOK',
      [ACC_LBL_ADD_NEW_ADDRESS_CTA]: 'ADD NEW ADDRESS',
      [ACC_LBL_DELETE_ADDRESS_HEADING]: 'DELETE ADDRESS',
      [ACC_LBL_DELETE_ADDRESS_TITLE]: 'Are you sure you want to delete this address?',
      [lblDeleteAddressModalCcAssociatedAddressMsg]:
        'Credit cards associated with this address will also be deleted',
      [ACC_LBL_ADD_ADDRESS_FORM_HEADING]: 'ADD NEW SHIPPING ADDRESS',
      [ACC_LBL_EDIT_ADDRESS]: 'EDIT SHIPPING ADDRESS',
      [ACC_LBL_EDIT_ADDRESS_FORM_HEADING]: 'EDIT SHIPPING ADDRESS',
      [ACC_LBL_CREATE_ADDRESS_BOOK_MSG]: 'Create an Address Book to check out faster!',
      [ACC_LBL_CREATE_ADDRESS_BOOK_BENEFIT_MSG]:
        'Add and save up to 5 shipping addresses so you can speed through the checkout process the next time you shop.',
      [ACC_LBL_DEFAULT_SHIPPING]: 'DEFAULT SHIPPING',
      [ACC_LBL_SHIPPING]: 'SHIPPING',
      [ACC_LBL_DEFAULT_BILLING]: 'DEFAULT BILLING',
    },
    common: {
      [lblCommonSuccessMessage]: 'Your account has been updated',
      [lblCommonDontDelete]: "No, Don't Delete",
      [lblCommonYesDelete]: 'Yes, Delete',
      [lblCommonMakeDefault]: 'Make Default',
      [lblCommonDelete]: 'Delete',
      [lblCommonErrorMessage]: 'Your action could not be completed due to a system error',
    },
  },
};
export default AddressBookLabels;
